// Mock data for medical visits - based on Bulgarian healthcare XML structure

export const mockVisits = [];

// Helper function to get visits by patient ID
export const getVisitsByPatientId = (patientId) => {
  return mockVisits.filter(visit => visit.patientId === patientId);
};

// Helper function to get a single visit by ID
export const getVisitById = (visitId) => {
  return mockVisits.find(visit => visit.id === visitId);
};

// Helper function to get all visits
export const getAllVisits = () => {
  return mockVisits;
};